import React from "react";
import {GoogleMaps} from "../../context/GoogleMapsContext";

class GoogleMap extends React.Component{

    constructor(props) {
        super(props);
        this.ref = React.createRef()
        this.childProps = Object.keys(props).reduce((accum, val) => {
            if (val !== 'children'){
                accum[val] = props[val]
            }
            return accum
        }, {})
    }

    componentDidMount() {
        this.props.children(this)
    }

    get api(){
        return window.google.maps
    }

    createMap(options){
        return new this.api.Map(this.ref.current, options)
    }

    render(){
        return <div ref={this.ref} {...this.childProps}/>
    }
}

export default (props) => {
    return (
        <GoogleMaps.Consumer>
            {context => context.loaded ? <GoogleMap {...props} /> : ""}
        </GoogleMaps.Consumer>
    )
}